import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import riskAssessmentAttachmentService from "../../services/riskAssessmentAttachmentService";

const useRiskAssessmentAttachments = (riskAssessmentId?: number | null) =>
    useQuery(
        [queryKeys.riskAssessmentAttachments, riskAssessmentId],
        () => riskAssessmentAttachmentService.fetchAttachments(riskAssessmentId),
        { enabled: !!riskAssessmentId }
    );

export default useRiskAssessmentAttachments;
